import script from "./Dns01Provider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dns01Provider.vue?vue&type=script&setup=true&lang=ts"

import "./Dns01Provider.vue?vue&type=style&index=0&id=31dfa91f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31dfa91f"]])

export default __exports__